import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const StudentClasses = () => {
  const routes = all_routes;
  const [activeTab, setActiveTab] = useState("today");

  // Mock data for enrolled classes
  const classesData = {
    today: [
      {
        id: 1,
        subject: "Mathematics",
        teacher: "Ms. Johnson",
        room: "Room 201",
        time: "9:00 AM - 9:45 AM",
        status: "completed",
        grade: "Grade 11A",
      },
      {
        id: 2,
        subject: "English Literature",
        teacher: "Mr. Davis",
        room: "Room 105",
        time: "10:00 AM - 10:45 AM",
        status: "completed",
        grade: "Grade 11A",
      },
      {
        id: 3,
        subject: "Physics Lab",
        teacher: "Dr. Smith",
        room: "Lab 1",
        time: "11:00 AM - 12:00 PM",
        status: "ongoing",
        grade: "Grade 11A",
      },
      {
        id: 4,
        subject: "History",
        teacher: "Ms. Wilson",
        room: "Room 302",
        time: "1:00 PM - 1:45 PM",
        status: "upcoming",
        grade: "Grade 11A",
      },
    ],
    enrolled: [
      {
        id: 1,
        subject: "Mathematics",
        teacher: "Ms. Johnson",
        room: "Room 201",
        schedule: "Mon, Wed, Fri - 9:00 AM",
        credits: 4,
        grade: "Grade 11A",
      },
      {
        id: 2,
        subject: "English Literature",
        teacher: "Mr. Davis",
        room: "Room 105",
        schedule: "Tue, Thu - 10:00 AM",
        credits: 3,
        grade: "Grade 11A",
      },
      {
        id: 3,
        subject: "Physics",
        teacher: "Dr. Smith",
        room: "Lab 1",
        schedule: "Mon, Wed - 11:00 AM",
        credits: 4,
        grade: "Grade 11A",
      },
      {
        id: 4,
        subject: "History",
        teacher: "Ms. Wilson",
        room: "Room 302",
        schedule: "Tue, Fri - 1:00 PM",
        credits: 3,
        grade: "Grade 11A",
      },
      {
        id: 5,
        subject: "Chemistry",
        teacher: "Dr. Brown",
        room: "Lab 2",
        schedule: "Thu - 2:00 PM",
        credits: 4,
        grade: "Grade 11A",
      },
      {
        id: 6,
        subject: "Physical Education",
        teacher: "Coach Martinez",
        room: "Gymnasium",
        schedule: "Mon, Wed, Fri - 3:00 PM",
        credits: 2,
        grade: "Grade 11A",
      },
    ],
  };

  const renderTodayClasses = () => {
    return classesData.today.map((classItem) => (
      <div key={classItem.id} className="card mb-3">
        <div className="card-body">
          <div className="d-flex align-items-center">
            <div
              className={`avatar avatar-sm me-3 ${
                classItem.status === "completed"
                  ? "bg-success"
                  : classItem.status === "ongoing"
                  ? "bg-warning"
                  : "bg-info"
              }`}
            >
              <i
                className={`ti ${
                  classItem.status === "completed"
                    ? "ti-check"
                    : classItem.status === "ongoing"
                    ? "ti-clock"
                    : "ti-calendar"
                } text-white`}
              ></i>
            </div>
            <div className="flex-fill">
              <div className="d-flex align-items-center justify-content-between">
                <h6 className="mb-1">{classItem.subject}</h6>
                <span
                  className={`badge ${
                    classItem.status === "completed"
                      ? "bg-success"
                      : classItem.status === "ongoing"
                      ? "bg-warning"
                      : "bg-info"
                  }`}
                >
                  {classItem.status === "completed"
                    ? "Completed"
                    : classItem.status === "ongoing"
                    ? "Ongoing"
                    : "Upcoming"}
                </span>
              </div>
              <p className="text-muted mb-1">
                <i className="ti ti-user me-1"></i>
                {classItem.teacher}
              </p>
              <p className="text-muted mb-0">
                <i className="ti ti-map-pin me-1"></i>
                {classItem.room} • {classItem.time}
              </p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderEnrolledClasses = () => {
    return classesData.enrolled.map((classItem) => (
      <div key={classItem.id} className="card mb-3">
        <div className="card-body">
          <div className="d-flex align-items-center">
            <div className="avatar avatar-sm bg-primary me-3">
              <i className="ti ti-book text-white"></i>
            </div>
            <div className="flex-fill">
              <div className="d-flex align-items-center justify-content-between">
                <h6 className="mb-1">{classItem.subject}</h6>
                <span className="badge bg-primary">
                  {classItem.credits} Credits
                </span>
              </div>
              <p className="text-muted mb-1">
                <i className="ti ti-user me-1"></i>
                {classItem.teacher}
              </p>
              <p className="text-muted mb-1">
                <i className="ti ti-map-pin me-1"></i>
                {classItem.room}
              </p>
              <p className="text-muted mb-0">
                <i className="ti ti-clock me-1"></i>
                {classItem.schedule}
              </p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">My Classes</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="card bg-primary">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>My Classes</h3>
                      <p>Manage your enrolled classes and today's schedule</p>
                    </div>
                    <div className="avatar avatar-lg">
                      <i className="ti ti-book text-white fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tab Navigation */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <ul className="nav nav-tabs card-header-tabs">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "today" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("today")}
                      >
                        <i className="ti ti-calendar-time me-2"></i>
                        Today's Classes
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "enrolled" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("enrolled")}
                      >
                        <i className="ti ti-book me-2"></i>
                        All Enrolled Classes
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="card-body">
                  {activeTab === "today" && (
                    <div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h5 className="mb-0">Today's Schedule</h5>
                        <Link
                          to={routes.studentTimeTable}
                          className="btn btn-primary btn-sm"
                        >
                          <i className="ti ti-calendar me-1"></i>
                          Full Schedule
                        </Link>
                      </div>
                      {classesData.today.length > 0 ? (
                        renderTodayClasses()
                      ) : (
                        <div className="text-center py-4">
                          <div className="avatar avatar-lg bg-light mb-3">
                            <i className="ti ti-calendar-off fs-2 text-muted"></i>
                          </div>
                          <h5>No classes today</h5>
                          <p className="text-muted">Enjoy your free day!</p>
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab === "enrolled" && (
                    <div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h5 className="mb-0">
                          Enrolled Classes ({classesData.enrolled.length})
                        </h5>
                        <div className="text-muted">
                          Total Credits:{" "}
                          {classesData.enrolled.reduce(
                            (sum, cls) => sum + cls.credits,
                            0
                          )}
                        </div>
                      </div>
                      {classesData.enrolled.length > 0 ? (
                        renderEnrolledClasses()
                      ) : (
                        <div className="text-center py-4">
                          <div className="avatar avatar-lg bg-light mb-3">
                            <i className="ti ti-book-off fs-2 text-muted"></i>
                          </div>
                          <h5>No enrolled classes</h5>
                          <p className="text-muted">
                            Contact administration to enroll in classes.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentClasses;
